import DOMPurify from "dompurify";

export const sanitizeHtml = (value: unknown): string =>
	DOMPurify.sanitize(String(value ?? ""), {
		USE_PROFILES: { html: true },
	});
